import React, { type ReactNode } from 'react';
import type {
	EnhancedUFOInteractionContextType,
	ReactProfilerTiming,
} from '@atlaskit/react-ufo/common';
import { fg } from '@atlassian/jira-feature-gating';

/**
 * this is a counterpart of the similar component in the .server implementation
 */
const ProfilerMarker = () => {
	return null;
};
const SsrRenderProfiler = ({
	children,
}: {
	children?: ReactNode | undefined;
	labelStack: ReactProfilerTiming['labelStack'];
	onRender: EnhancedUFOInteractionContextType['onRender'];
}) => {
	// eslint-disable-next-line jira/ff/no-preconditioning
	if (fg('jfp_magma_jira-use-id-sync') && fg('jira-ssr-enable-ufo-in-ssr')) {
		// ensure structure similar to SSR implementation
		return (
			<>
				<ProfilerMarker />
				{children}
			</>
		);
	}
	return <>{children}</>;
};
export default SsrRenderProfiler;
